<script>
import api from "@/api";

export default {
  components: {},

  data: function() {
    return {
      schedule: null,
      code: null,
      returnPath: null,
    };
  },
  methods: {
    fetchData() {
      console.log("Fetch data.....");
      api
        .getSportsEngineAccessToken(this.code, {
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          timezone_offset: this.$moment(new Date()).format("Z"),
        })
        .then(response => {
          console.log("FD callback", response.data);
          this.$store.commit("setUser", response.data);
          setTimeout(() => {
            console.log("Now going...");
            if (this.returnPath) {
              this.goRouter(this.returnPath + "?refresh=1");
            }
            this.refreshLeagueInformation();
            setTimeout(() => {
              this.goRouter("/sportsengine");
              this.makeToast("success", this.$t("Toast.account_connected"));
            }, 1000);
          }, 1000);
        })
        .catch(e => {
          alert(
            "Something went wrong. Please try again and share the following message with support if the issue persists:" +
              e,
          );
          this.trackEvent("Error Reconnecting SportsEngine", { error: e, code: this.code });
        });
    },
  },
  mounted() {
    console.log("Callback");
    var returnPath = this.getURLParam("return");
    if (returnPath) {
      this.returnPath = returnPath;
    }
    this.code = this.getURLParam("code");
    if (this.code) {
      this.fetchData();
    }
  },
};
</script>

<template>
  <div><ProgressSpinner /></div>
</template>

<style></style>
